<template lang="pug">
div(class="flex gap-x-4")
    div(class="flex-none")
        div(class="w-full max-w-[64px]")
            img(
                v-if="item.image"
                :src="$getImageUrl(item.image.key, item.image.filename, 64, 64)"
                width="64"
                height="64"
                :alt="item.productLineName"
                class="border"
            )
            p(class="ml-auto w-5 h-5 translate-x-2.5 -translate-y-2.5 text-sm rounded-full bg-primary flex flex-col justify-center items-center font-bold") {{ item.qty }}

    div(class="flex-1")
        div(class="flex justify-between gap-x-2")
            div(class="text-sm")
                p(class="font-bold") {{ item.productLineName }}
                dl
                    dd(v-if="$sitewideData.config.showMpn") {{ item.mpn }}
                    dd(v-else) {{ item.sku }}

                    dd(v-if="itemFitment") {{ itemFitment }}

                    dd(v-if="item.warranty") {{ item.warranty.termLength }} month #[span(class="font-bold") Extend] warranty

                    dd(v-if="item.installation") #[span(class="font-bold") RealPro] Installation included

            p(class="font-bold") {{ itemSubtotal }}

</template>

<script>
import { formatCents } from '@/helpers/filters'

export default {
    name: 'CartItem',
    props: {
        item: {
            type: Object,
            default() {
                return null
            },
        },
    },
    computed: {
        itemFitment() {
            // Full fitment
            const fitment = []

            const { year, makeName, modelName, bedName, bodyName, engineName, appNote } =
                this.item.fitmentData || {}

            let primaryFitment = null

            if (year) primaryFitment = year
            if (makeName) primaryFitment += ` ${makeName}`
            if (modelName) primaryFitment += ` ${modelName}`

            if (primaryFitment) fitment.push(primaryFitment)

            if (bedName) fitment.push(bedName)
            if (bodyName) fitment.push(bodyName)
            if (engineName) fitment.push(engineName)
            if (appNote) fitment.push(appNote)

            return fitment.join(', ')
        },
        itemSubtotal() {
            return formatCents(this.item.saleSubtotal)
        },
    },
}
</script>
